<div class="dsh-caption">
    <ng-container *ngIf="!hidden"><ng-content></ng-content></ng-container>
</div>
